import React, { Component } from "react";
import Autosuggest from 'react-autosuggest';
import "./theme.css";
//import { theme } from 'react-autosuggest/dist/theme';
import {
  Breadcrumb,
  BreadcrumbItem,
  Button,
  FormGroup,
  Label, 
  Input
} from "reactstrap";
import { Link } from "react-router-dom";
import { ToastContainer, toast, Slide } from "react-toastify";
import httpClient from "../../http-client/client";
import ListAgentInvoice from "../../components/listAgentInvoice";
import {AgentService } from "../../services";

//---------------------------------------------------

class Invoice extends Component {
    constructor() {
      super();
       // Autosuggest is a controlled component.
    // This means that you need to provide an input value
    // and an onChange handler that updates this value (see below).
    // Suggestions also need to be provided to the Autosuggest,
    // and they are initially empty because the Autosuggest is closed.
      this.state = {
        businessNames: [],
        value: "",
        agentId:"",
        suggestions: [],
        data: [], 
        canNotAddMoreUser: true
       };
      this.agentService = new AgentService();

    }
// Teach Autosuggest how to calculate suggestions for any given input value.
 getSuggestions = value => {
  const inputValue = value.trim().toLowerCase();
  const inputLength = inputValue.length;
 //console.log("textbox name ",value);
  return inputLength === 0 ? [] : this.state.businessNames.filter(business =>
    business.business_name.toLowerCase().slice(0, inputLength) === inputValue
  );
};


// When suggestion is clicked, Autosuggest needs to populate the input
// based on the clicked suggestion. Teach Autosuggest how to calculate the
// input value for every given suggestion.
 //getSuggestionValue = suggestion => suggestion.business_name

 getSuggestionValue=(suggestion)=> {
  this.setState({                         //we can only return string
                                         //Error:use =>
    agentId: suggestion.agent_id   // it will get agent id from the selected name
  });
 // console.log("getSuggestionValue",suggestion.agent_id);
  return suggestion.business_name;
}
  //  let value= suggestion.agent_id;
  //  console.log("SUBMIT BUTTON VALUE",value);
  //  }
//  handleSubmitbutton = () => {
//   if (!this.state.agentId) {
//     alert("Please Enter Busines name to search")
//   }
//  console.log("SUBMIT BUTTON Id",this.state.agentId);
//   }
// Use your imagination to render suggestions.
 renderSuggestion = suggestion => (

 <div  className="searchbar" >
    {suggestion.business_name}
  </div>
);    
    onChange = (event, { newValue }) => {
      console.log("ONCHANGE VALUE",newValue);
      this.setState({
        value: newValue
      });
 
    };
  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.getSuggestions(value)
    });
  };
  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };
  
    componentDidMount() {
      this.getBusinessName();
     //this.getUsers();
    }  
    getBusinessName = async () => {
      try {
        let { data } = await this.agentService.getBusinessName();
        this.setState({ businessNames: data["response"][0] });
        console.log("MY bUSINESS NAMES",data);
      } catch (error) {
        console.log("error",error);
      }
    };
    
  // reset = () => {
  //   this.state = {
  //     value : "",
     
  //   };
  // }
    getUsers = async () => {
      try {
        console.log("Agent Id in getusers",this.state.agentId); 
        let { data } = await httpClient.get(`/agent/get_invoice/${this.state.agentId}`);
        //this.reset();
        //console.log("Get Agent Invoice list Data ",data);
       
        this.setState({ data:data["response"][0], canNotAddMoreUser: (data["response"][0]).length > 2  });
      } catch (error) {
        toast.error("Please enter correct name to search", {
          position: toast.POSITION.BOTTOM_RIGHT,
          transition: Slide
        });
        this.setState({ data: [] });
      }
    };
  
    render() {
      const { value, suggestions} = this.state;
     // console.log("My suggestion Agent Id",agentId);
       // Autosuggest will pass through all these props to the input.
    const inputProps = {
      placeholder:'ایجنٹ کا نام درج کریں',
      value,
      onChange: this.onChange
    };
      return (
        <div>
          <Breadcrumb style={{ marginTop: "1%" }}>
            <BreadcrumbItem>
              <Link to="/dashboard">Dashbarod</Link>
            </BreadcrumbItem>
  
            <BreadcrumbItem active>Invoices</BreadcrumbItem>
          </Breadcrumb>
          
          <div className="mt-3 ">
          <div  className="row text-right ">
          <FormGroup   className="col-sm-12 col-md-4 bar">
          <Label >ایجنٹ کا نام</Label>
                                       
          <Autosuggest
        suggestions ={suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        getSuggestionValue={this.getSuggestionValue}
        renderSuggestion={this.renderSuggestion}
        inputProps={inputProps}
        
      />
      </FormGroup>

            <div
              className="col-sm-12 col-md-2 mt-3"
              style={{
                marginLeft:'25%',
                paddingTop:15,
                display: "flex",
                alignItems: "center",
                
                justifyContent: "center",
                position : "absolute" 
              }}
            >
     
              <Button color="secondary"  size="sm" onClick={this.getUsers} >
                <i className="fas fa-file-alt"></i> Search Invoice
              </Button>
         
            </div>
          </div>
        </div>
          <div className="mt-3">
          
            <ListAgentInvoice data={this.state.data}  getUsers={this.getUsers}/>
            
          </div>       
        </div>
      );
    }
  }
  
  export default Invoice;
  
